import TaxesDetails from "../../../../components/TaxesDetails";
import CustomButton from "../../../../components/CustomButton";
import ImportFiles from "../../../../components/ImportFiles";
import fileIcon from "../../../../assets/fileIcon.png";
import StatusButton from "../../../../components/StatusButton";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useContainerStore from "../../../../store/containerStore";
import { FaCoins } from "react-icons/fa6";
import AddOrderLoad from "../../../../components/AddLoadOrder";
import useOrderItemsLoadStore from "../../../../store/orderItemsLoadStore";
import api from "../../../../services/api";
import { v4 as uuidv4 } from "uuid";
import { uploadFile } from "../../../../axios/uploadFiles";
import Spinner from "../../../../components/SpinnerLoading";
import useAttachmentsStore from "../../../../store/attachmentsStore";
import plusIcon from "../../../../assets/plusIcon.png";

import React from "react";
import useUserStore from "../../../../store/userStore";
import { FaMinusSquare } from "react-icons/fa";

//MODAL NOVA CARGA
const Modal = ({ isOpen, onClose, title, message, isError }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-lg p-6">
        <h2
          className={`text-lg font-bold ${
            isError ? "text-red-600" : "text-green-600"
          }`}
        >
          {title}
        </h2>
        <p className="mt-4 text-gray-700">{message}</p>
        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark transition"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

const NovaCarga = () => {
  const navigate = useNavigate();
  const [transitTime, setTransitTime] = useState("");
  const [isModalContainerOpen, setIsModalContainerOpen] = useState(false);
  const [isModalAgentOpen, setIsModalAgentOpen] = useState(false);
  const [selectedContainer, setSelectedContainer] = useState("");
  const [listContainer, setListContainers] = useState([]);
  const [error, setError] = useState(null);
  const [cmv, setCmvValue] = useState("");
  const [landShipping, setLandShipping] = useState("");
  const [otherTaxes, setOtherTaxes] = useState("");

  const [seaFreight, setSeaFreight] = useState("");
  const [valueCIF, setValueCIF] = useState("");
  const { orderItemsLoad, clearOrderItemsLoad } = useOrderItemsLoadStore();
  const [isLoading, setIsLoading] = useState(false);
  const { containers, getAllContainers } = useContainerStore();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState("");
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const { users, getAllUsers } = useUserStore();
  const [selectedContainers, setSelectedContainers] = useState([]);
  const [prevision, setPrevision] = useState("");
  const [isLoadingPdfUploadFirst, setIsLoadingPdfUploadFirst] = useState(false);
  const [isLoadingPdfUploadSecond, setIsLoadingPdfUploadSecond] =
    useState(false);
  const [isLoadingPdfUploadThird, setIsLoadingPdfUploadThird] = useState(false);
  const [isLoadingPdfUploadFourth, setIsLoadingPdfUploadFourth] =
    useState(false);
  const [isUploadFirstInputDone, setIsUploadFirstInputDone] = useState(false);
  const [isUploadSecondInputDone, setIsUploadSecondInputDone] = useState(false);
  const [isUploadThirdInputDone, setIsUploadThirdInputDone] = useState(false);
  const [isUploadFourthInputDone, setIsUploadFourthInputDone] = useState(false);

  useEffect(() => {
    getAllContainers();
  }, [getAllContainers]);

  useEffect(() => {
    getAllUsers();
  }, [getAllUsers]);

  const handleContainerChange = (container) => {
    setSelectedContainer(container);
  };

  const handleAddContainer = () => {
    if (!selectedContainer) return alert("Por favor, selecione um contêiner");

    setSelectedContainers((prevState) => [...prevState, selectedContainer]);

    //setSelectedContainer(null);
  };

  const removeContainer = (index) => {
    setSelectedContainers((prevState) =>
      prevState.filter((_, i) => i !== index)
    );
  };

  const handleAgentChange = (agent) => {
    setSelectedAgent(agent.name);
    setSelectedAgentId(agent.id);
  };

  useEffect(() => {
    const forb = orderItemsLoad.reduce((acc, item) => {
      return acc + Number(item.target_value * item.quantity);
    }, 0);
    setCmvValue(
      forb.toLocaleString("pt-BR", { style: "currency", currency: "USD" })
    );
  }, [orderItemsLoad]);

  const handleValuesChanges = (updatedValues) => {
    setLandShipping(updatedValues.landShipping);
    setOtherTaxes(updatedValues.otherTaxes);
    setPrevision(updatedValues.prevision);
    setSeaFreight(updatedValues.seaFreight);
    setValueCIF(updatedValues.valueCIF);
  };

  const validateNumericInput = (e) => {
    const inputValue = e.target.value.replace(/\D/g, "");
    return inputValue; // Retorna apenas os números
  };

  const { addAttachment, clearAttachments, attachments } =
    useAttachmentsStore();
  const handleFileUpload = async (e, inputNumber, description) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        alert("Por favor, selecione um arquivo PDF.");
        return;
      }

      const MAX_FILE_SIZE = 5 * 1024 * 1024;
      if (file.size > MAX_FILE_SIZE) {
        alert("O arquivo excede o tamanho máximo permitido de 5MB.");
        return;
      }

      const tempReferenceId = uuidv4();
      if (inputNumber === 1) {
        setIsLoadingPdfUploadFirst(true);
      } else if (inputNumber === 2) {
        setIsLoadingPdfUploadSecond(true);
      } else if (inputNumber === 3) {
        setIsLoadingPdfUploadThird(true);
      } else {
        setIsLoadingPdfUploadFourth(true);
      }

      try {
        const response = await uploadFile(file);
        const dbAttachmentsPost = {
          google_id: response.result.id,
          reference_id: tempReferenceId,
          reference_type: "TEMP",
          attachment_type: "LOAD_ATTACHMENT",
          attachment_description: description || response.result.name,
          privacy: "PUBLIC",
        };
        await api.post(`/attachments/create-attachment`, dbAttachmentsPost);

        addAttachment(dbAttachmentsPost.reference_id);
        const currentAttachments = useAttachmentsStore.getState().attachments;
        console.log("Estado atualizado no Zustand:", currentAttachments);

        alert("PDF enviado com sucesso!");

        console.log("inputNumber", inputNumber);

        if (inputNumber === 1) {
          setIsUploadFirstInputDone(true);
        } else if (inputNumber === 2) {
          setIsUploadSecondInputDone(true);
        } else if (inputNumber === 3) {
          console.log("setando 3 como true");
          setIsUploadThirdInputDone(true);
        } else {
          setIsUploadFourthInputDone(true);
        }
      } catch (error) {
        console.error("Erro ao enviar o arquivo:", error);
        alert(
          "Erro ao enviar o arquivo. Verifique sua conexão e tente novamente."
        );
      } finally {
        setIsLoadingPdfUploadFirst(false);
        setIsLoadingPdfUploadSecond(false);
        setIsLoadingPdfUploadThird(false);
        setIsLoadingPdfUploadFourth(false);
      }
    }
  };

  const items = [
    { id: "BL", label: "BL", active: false },
    { id: "DI", label: "DI", active: false },
    { id: "NM", label: "NM", active: false },
    { id: "PI", label: "PI", active: false },
    { id: "PL", label: "PL", active: true },
    { id: "CF", label: "CF", active: true },
  ];

  const handleChangeTransitTime = (e) => {
    const formatedValueNumber = validateNumericInput(e);
    setTransitTime(formatedValueNumber);
  };

  const toggleDropdown = () => {
    setIsModalContainerOpen(!isModalContainerOpen);
  };

  const onHandleNewOrderLoad = async (e) => {
    e.preventDefault();
    if (selectedContainers.length === 0) {
      alert("Adicione, ao menos, um Contêiner");
      return;
    }

    setIsLoading(true);
    try {
      const newOrderLoad = {
        containers_type: selectedContainers,
        name_previsions: prevision,
        agent_id: selectedAgentId,
        transit_time: parseInt(transitTime),
        order_load_items: orderItemsLoad,
        cmv_value: cmv,
        cif_value: valueCIF,
        another_tax_value: otherTaxes,
        maritime_freight_value: seaFreight,
        land_freight_value: landShipping,
      };

      const orderRes = await api.post(
        "/order-load/create-order-load",
        newOrderLoad
      );
      setModalTitle("Sucesso!");
      setModalMessage("Carga adicionada com sucesso!");
      setIsErrorModal(false);
      setModalOpen(true);

      const orderId = orderRes?.data?.orderLoad.id;

      if (orderId) {
        await api.put("/attachments/update-reference", {
          temp_reference_ids: attachments,
          order_id: orderId,
          reference_type: "LOAD",
        });
      } else {
        throw new Error("Failed to retrieve order ID.");
      }

      clearAttachments();
      clearOrderItemsLoad();
    } catch (error) {
      const errorMessage =
        error.response?.status !== 500
          ? error.response?.data?.error || "Erro desconhecido."
          : "Ocorreu um erro no servidor. Por favor, tente novamente mais tarde.";

      setModalTitle("Erro!");
      setModalMessage(errorMessage);
      setIsErrorModal(true);
      setModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
          if (!isErrorModal) navigate("/cargas");
        }}
        title={modalTitle}
        message={modalMessage}
        isError={isErrorModal}
      />
      <form onSubmit={onHandleNewOrderLoad}>
        <div className="flex justify-between text-boldGray font-bold ">
          <div className="  px-2 rounded-md h-[90px] flex gap-6 mb-20">
            <div className="flex h-44 flex-col w-full bg-extraLightGray rounded-md">
              <label
                className="text-gray-700 font-semibold my-2 text-center"
                htmlFor="container-input"
              >
                Adicionar Contêiner
              </label>
              <div className="flex flex-col gap-2 max-h-28 overflow-y-auto custom-scrollbar">
                {selectedContainers.map((container, index) => (
                  <div className="border-2 p-2 pr-0 flex justify-between items-center">
                    <p>{container}</p>
                    <button
                      className="text-red-500 w-8"
                      onClick={() => removeContainer(index)}
                      type="button"
                    >
                      <FaMinusSquare />
                    </button>
                  </div>
                ))}
              </div>
              <div className="flex flex-col flex-grow justify-end">
                <div className="relative w-full flex">
                  <input
                    id="container-input"
                    type="text"
                    className="w-[20] border-2 border-gray-400 mr-2 px-4 py-2 bg-gray-100 rounded-lg text-gray-900 cursor-pointer focus:outline-none"
                    placeholder="Selecione um contêiner"
                    value={selectedContainer}
                    onClick={toggleDropdown}
                    required
                    autoComplete="off"
                  />

                  {/* Dropdown de opções */}
                  {isModalContainerOpen && (
                    <div className="absolute z-10 mt-2 flex flex-col p-2 space-y-2 bg-gray-100 rounded-lg shadow-lg w-full">
                      {containers.map((option) => (
                        <div
                          key={option.id}
                          className="flex justify-center items-center px-4 py-2 bg-gray-200 rounded-full cursor-pointer text-gray-800 hover:bg-gray-300 transition"
                          onClick={() => {
                            handleContainerChange(option.type_container);
                            toggleDropdown();
                          }}
                        >
                          {option.type_container}
                        </div>
                      ))}
                    </div>
                  )}
                  <button
                    className="flex items-center justify-center mr-4 w-6"
                    onClick={handleAddContainer}
                    type="button"
                  >
                    <img src={plusIcon} alt="Adicionar" />
                  </button>
                </div>
              </div>
            </div>
            <div className="flex flex-col w-full bg-extraLightGray  rounded-md">
              <label
                className="text-gray-700 font-semibold mb-2 text-center"
                htmlFor="container-input"
              >
                Adicionar Agente
              </label>
              <div className="relative w-full">
                <input
                  id="container-input"
                  type="text"
                  className="w-full px-4 py-2 bg-gray-100 rounded-lg text-gray-900 cursor-pointer focus:outline-none"
                  placeholder="Selecione um agente"
                  value={selectedAgent}
                  onClick={() => setIsModalAgentOpen(!isModalAgentOpen)}
                  autoComplete="off"
                />
                <svg
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500"
                  style={{
                    transform: isModalAgentOpen ? "rotate(180deg)" : "",
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
                {/* Dropdown de opções */}
                {isModalAgentOpen && (
                  <div className="absolute z-10 mt-2 flex flex-col p-2 space-y-2 bg-gray-100 rounded-lg shadow-lg w-full">
                    {users.map((user) => {
                      return user.accessType === "AGENT" ? (
                        <div
                          key={user.id}
                          className="flex justify-center items-center px-4 py-2 bg-gray-200 capitalize rounded-full cursor-pointer text-gray-800 hover:bg-gray-300 transition"
                          onClick={() => {
                            handleAgentChange(user);
                            setIsModalAgentOpen(!isModalAgentOpen);
                          }}
                        >
                          {user.name}
                        </div>
                      ) : (
                        ""
                      );
                    })}
                  </div>
                )}
              </div>
              {/* {listContainer.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-2 max-w-full">
                  {listContainer.map((container, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center px-4 py-2 bg-gray-200 rounded-full text-gray-800"
                    >
                      {container}
                    </div>
                  ))}
                </div>
              )} */}
            </div>
          </div>

          <div className="flex h-[40px] items-center">
            <p>
              <strong>Transit Time</strong>
            </p>
            <div className="rounded-md bg-extraLightGray py-2 px-4 text-center ml-4 w-[122px] flex justify-evenly text-boldGray opacity-90">
              <input
                className="w-[40px] bg-transparent text-center outline-none"
                placeholder="0"
                value={transitTime}
                onChange={handleChangeTransitTime}
                required
              />
              dias
            </div>
          </div>
        </div>
        <AddOrderLoad />
        {/* <DetailsOrder order="C001-2024" items={orders} /> */}
        <div className="m-4 flex justify-between mt-8">
          <div className="flex items-center">
            <img src={fileIcon} alt="ícone de aqruivos" />
            <h2 className="font-bold ml-4 text-base text-boldGray">
              Importação de arquivos
            </h2>
          </div>
          <div className="flex w-[30%] justify-between">
            {items.map((item) => (
              <StatusButton
                key={item.id}
                label={item.label}
                active={item.active}
              />
            ))}
          </div>
        </div>
        <ImportFiles
          onUpload={handleFileUpload}
          handleFileUpload={handleFileUpload}
          isLoadingPdfUploadFirst={isLoadingPdfUploadFirst}
          isLoadingPdfUploadSecond={isLoadingPdfUploadSecond}
          isLoadingPdfUploadThird={isLoadingPdfUploadThird}
          isLoadingPdfUploadFourth={isLoadingPdfUploadFourth}
          isUploadFirstInputDone={isUploadFirstInputDone}
          isUploadSecondInputDone={isUploadSecondInputDone}
          isUploadThirdInputDone={isUploadThirdInputDone}
          isUploadFourthInputDone={isUploadFourthInputDone}
        />
        <h2 className="mt-10 flex items-center gap-4 font-bold ml-4 text-base text-boldGray">
          <FaCoins className="text-primary text-4xl" />
          Cálculo de taxas
        </h2>
        <TaxesDetails
          onValuesChange={handleValuesChanges}
          initialForbValue={cmv}
        />
        <div className="flex justify-center mt-4">
          <div className="w-[440px] h-[60px]">
            <CustomButton className="bg-primary text-white font-bold text-xl">
              {isLoading ? <Spinner>Salvando...</Spinner> : "Salvar Pedido"}
            </CustomButton>
          </div>
        </div>
      </form>
    </>
  );
};

export default NovaCarga;
